import { Component, Input } from '@angular/core';

/**
 * Refresh Required Modal Component
 *
 * Displays a blocking modal prompting the current tab to refresh.
 */
@Component({
    standalone: false,
    selector: 'ycn-refresh-required-modal',
    templateUrl: './refresh-required-modal.template.html',
})
export class RefreshRequiredModalComponent {
    @Input() refreshMessage!: string;

    modalOpen: boolean = false;

    openModal(): void {
        this.modalOpen = true;
    }

    closeModal(): void {
        this.modalOpen = false;
    }
}
